<mat-card style="border-color: #5775a8;">
  <mat-card-header cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle style="background-color: #5775a8;">
    <div class="flex flex-row rounded-lg w-full" style="align-items: center;">
      <div class="flex flex-col w-full" style="padding-right: 20px;">
        <h4 style="color:white;">Report an Enclosed Area</h4>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content>
    <form [formGroup]="form">
      <div class="modal fade" id="enclosedAreaModal" tabindex="-1" role="dialog"
        aria-labelledby="enclosedAreaModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div>
              <div class="row">
                <mat-form-field class="container">
                  <mat-label>Visit Date</mat-label>
                  <input matInput [matDatepicker]="visitDate" (dateChange)="dateChanged($event.target.value)"
                    formControlName="visitDate">
                  <mat-datepicker-toggle matSuffix [for]="visitDate"></mat-datepicker-toggle>
                  <mat-datepicker #visitDate></mat-datepicker>
                  <mat-error *ngIf="form.get('visitDate').invalid">
                    Invalid Date.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="row"><br /></div>
              <div class="row">
                <mat-form-field class="w-full">
                  <mat-label>Comments</mat-label>
                  <textarea matInput cdkTextareaAutosize formControlName="comments" cdkAutosizeMinRows="6"></textarea>
                </mat-form-field>
              </div>
              <div class="flex flex-col w-full" *ngIf="enclosedArea.enclosedAreaReviewed">
                <span style="color:orange;">
                  <p>
                    This business has already had an enclosed area reviewed by OHA on
                    <strong>{{enclosedArea.enclosedAreaDetermination}}</strong>.
                    <br />Submitting this form will prompt a new enclosed area review process.
                  </p>
                </span>
              </div>
            </div>
            <div class="modal-footer">
              <div class="flex flex-row ">
                <div style="padding-right: 20px;" *ngIf="showSave">
                  <button mat-raised-button (click)="save()" class="m-8 container" style="background: #7ABDF3;">
                    Save
                  </button>
                </div>
                <div style="padding-right: 20px;">
                  <button mat-raised-button (click)="return()" class="m-8 container">
                    Return
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </form>

  </mat-card-content>

</mat-card>